function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 36 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M17.05.01A26.947 26.947 0 0134.78 9.045c.914 1.04.658 2.616-.462 3.43L18.526 23.948c-1.657 1.204-3.98.02-3.98-2.028V2.4c0-1.384 1.125-2.519 2.503-2.39z",
  fill: "url(#paint0_linear)"
}), React.createElement("circle", {
  cx: "15.667",
  cy: "24.333",
  transform: "rotate(-90 15.667 24.333)",
  fill: "#96F",
  r: "15.667"
}), React.createElement("path", {
  d: "M29.1 16.267l-10.574 7.681c-1.657 1.204-3.98.02-3.98-2.028V8.706c.37-.026.744-.04 1.12-.04 5.703 0 10.693 3.047 13.433 7.6z",
  fill: "url(#paint1_linear)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "25.693",
  y1: "-.106",
  x2: "25.693",
  y2: "20.573",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: ".237",
  stopColor: "#FF5191"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#E03071"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "21.307",
  y1: "24.96",
  x2: "16.841",
  y2: "7.433",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6E00F5"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#9860FE"
})))));